<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveControl()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Nome do Controle
                  <span class="info-tooltip" data-tooltip="Nome que identifica este controle. Ex: Escolas, Empresas, Delegações"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <input
                  id="name"
                  v-model="control.name"
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Ex: Escolas, Empresas, Delegações..."
                  :class="{ 'is-invalid': submitted && $v.control.name.$error }"
                />
                <div v-if="submitted && !$v.control.name.required" class="invalid-feedback">
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="identifier_label">Título do campo
                  <span class="info-tooltip" data-tooltip="Nome visível para o inscrito no formulário de inscrição. Ex: 'INEP', 'CNPJ', 'Matrícula'"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <input
                  id="identifier_label"
                  v-model="control.identifier_label"
                  type="text"
                  class="form-control"
                  placeholder="Ex: INEP, CNPJ, Matrícula..."
                  :class="{ 'is-invalid': submitted && $v.control.identifier_label.$error }"
                  @input="control.identifier_field = slugify(control.identifier_label)"
                />
                <div v-if="submitted && !$v.control.identifier_label.required" class="invalid-feedback">
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="identifier_field">Chave interna
                  <span class="info-tooltip" data-tooltip="Nome técnico do campo identificador, sem espaços ou acentos. É o campo-chave que vincula o inscrito ao item. Ex: 'inep', 'cnpj', 'matricula'"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <input
                  id="identifier_field"
                  v-model="control.identifier_field"
                  type="text"
                  placeholder="Ex: inep, cnpj, matricula..."
                  class="form-control bg-light"
                  :class="{ 'is-invalid': submitted && $v.control.identifier_field.$error }"
                  disabled
                />
                <div v-if="submitted && !$v.control.identifier_field.required" class="invalid-feedback">
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div :class="maskType === 'custom' ? 'col-sm-6' : 'col-sm-12'">
              <div class="form-group">
                <label for="mask_type">Máscara do Identificador
                  <span class="info-tooltip" data-tooltip="Aplica formatação automática ao campo identificador. Ex: CPF formata como 000.000.000-00"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <select
                  id="mask_type"
                  v-model="maskType"
                  class="form-control"
                  @change="onMaskTypeChange"
                >
                  <option value="">Nenhuma</option>
                  <option value="###.###.###-##">CPF</option>
                  <option value="##.###.###/####-##">CNPJ</option>
                  <option value="(##) #####-####">Telefone</option>
                  <option value="#####-###">CEP</option>
                  <option value="custom">Personalizada</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6" v-if="maskType === 'custom'">
              <div class="form-group">
                <label for="custom_mask">Máscara personalizada
                  <span class="info-tooltip" data-tooltip="Tokens: # = dígito, A = letra, S = alfanumérico. Demais caracteres são literais. Ex: AA-####/##"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <input
                  id="custom_mask"
                  v-model="control.identifier_mask"
                  type="text"
                  class="form-control"
                  placeholder="Ex: AA-####/##"
                />
                <small class="text-muted" v-if="control.identifier_mask">
                  Preview: {{ maskPreview }}
                </small>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="vacancy_mode">Modo de Vagas
                  <span class="info-tooltip" data-tooltip="Individual: cada item tem seu próprio limite. Em grupo: o limite é compartilhado entre todos os itens do grupo. Individual + Grupo: cada item tem limite próprio E o grupo também tem limite total (o mais restritivo prevalece)."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <select
                  id="vacancy_mode"
                  v-model="control.vacancy_mode"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.control.vacancy_mode.$error }"
                >
                  <option value="per_item">Individual</option>
                  <option value="per_group">Em grupo</option>
                  <option value="per_item_and_group">Individual + Grupo</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="active">Status
                  <span class="info-tooltip" data-tooltip="Controles inativos não serão exibidos na landing page"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <select
                  id="active"
                  v-model="control.active"
                  class="form-control"
                >
                  <option :value="true">Ativo</option>
                  <option :value="false">Inativo</option>
                </select>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="form_id">Formulário de Inscrição
                  <span class="info-tooltip" data-tooltip="Selecione o formulário que será exibido ao inscrito após validar o identificador"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <select
                  id="form_id"
                  v-model="control.form_id"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.control.form_id.$error }"
                >
                  <option :value="null" disabled>Selecione um formulário...</option>
                  <option v-for="form in forms" :key="form.id" :value="form.id">{{ form.name }}</option>
                </select>
                <div v-if="submitted && !$v.control.form_id.required" class="invalid-feedback">
                  Selecione um formulário.
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    v-model="control.assign_participant_group"
                    class="mr-2"
                  />
                  Definir grupo do participante pelo item
                  <span class="info-tooltip" data-tooltip="Quando ativado, cada item do controle poderá definir em qual grupo (F1, F2, VIP...) o participante será inserido ao se inscrever"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="vacancy_message">Mensagem quando vagas esgotadas
                  <span class="info-tooltip" data-tooltip="Texto exibido ao inscrito quando o limite de vagas do item ou grupo for atingido"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                  </svg></span>
                </label>
                <input
                  id="vacancy_message"
                  v-model="control.vacancy_message"
                  type="text"
                  class="form-control"
                  placeholder="Ex: Este código atingiu o limite de cadastros."
                />
              </div>
            </div>
          </div>

          <!-- Fields Schema Builder -->
          <div class="row mt-3">
            <div class="col-12">
              <label>Campos Customizados
                <span class="info-tooltip" data-tooltip="Campos extras que serão salvos em cada item. Ex: 'ID Arco', 'Prioridade'. Aparecerão na ficha do participante"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                </svg></span>
              </label>
              <div class="table-responsive" v-if="control.fields_schema && control.fields_schema.length > 0">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Label</th>
                      <th>Tipo</th>
                      <th width="60">#</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(field, index) in control.fields_schema">
                      <tr :key="index">
                        <td>
                          <input v-model="field.label" type="text" class="form-control form-control-sm" placeholder="Label de exibição" @input="field.name = slugify(field.label)" />
                        </td>
                        <td>
                          <select v-model="field.type" class="form-control form-control-sm" @change="onFieldTypeChange(field)">
                            <option value="text">Texto</option>
                            <option value="number">Número</option>
                            <option value="select">Seleção</option>
                            <option value="multiselect">Multi-seleção</option>
                          </select>
                        </td>
                        <td>
                          <button type="button" class="btn btn-outline-danger btn-sm" @click="removeField(index)">
                            <i class="bx bx-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="field.type === 'select' || field.type === 'multiselect'" :key="'opts_' + index">
                        <td colspan="3" class="bg-light p-2">
                          <label class="small text-muted mb-1">Opções</label>
                          <div v-for="(opt, oi) in field.options" :key="oi" class="d-flex align-items-center mb-1">
                            <input v-model="field.options[oi]" class="form-control form-control-sm" placeholder="Valor da opção" />
                            <button type="button" @click="field.options.splice(oi, 1)" class="btn btn-sm btn-outline-danger ml-1">
                              <i class="bx bx-x"></i>
                            </button>
                          </div>
                          <button type="button" @click="field.options.push('')" class="btn btn-outline-secondary btn-sm mt-1">
                            + Opção
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <button type="button" class="btn btn-outline-info btn-sm" @click="addField()">
                <i class="mdi mdi-plus mr-1"></i> Adicionar Campo
              </button>
            </div>
          </div>

          <!-- Grupos de Tags ─ bundles que serão referenciados pelos itens.
               Cada bundle = nome + lista de tag_ids. Quando um participante
               se inscreve com um item desse bundle, recebe automaticamente
               as tags do bundle. -->
          <div class="row mt-4">
            <div class="col-12">
              <label>Grupos de Tags
                <span class="info-tooltip" data-tooltip="Defina conjuntos nomeados de tags. Cada item pode apontar pra um grupo, e os participantes que se inscreverem nesse item recebem todas as tags do grupo automaticamente."><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="5" r="0.8" fill="currentColor"/><rect x="7.4" y="7" width="1.2" height="5" rx="0.6" fill="currentColor"/>
                </svg></span>
              </label>

              <div v-if="control.tag_bundles && control.tag_bundles.length > 0" class="tb-list">
                <div
                  v-for="(bundle, idx) in control.tag_bundles"
                  :key="bundle.id || ('tmp_' + idx)"
                  class="tb-card"
                >
                  <div class="tb-card-row">
                    <div class="tb-name-wrap">
                      <label class="small text-muted mb-1">Nome do grupo</label>
                      <input
                        v-model="bundle.name"
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Ex: Grupo 1"
                      />
                    </div>
                    <button type="button" class="btn btn-outline-danger btn-sm tb-remove" @click="removeBundle(idx)" title="Remover grupo">
                      <i class="bx bx-trash"></i>
                    </button>
                  </div>
                  <div class="mt-2">
                    <label class="small text-muted mb-1">Tags neste grupo</label>
                    <multiselect
                      v-model="bundle.selectedTags"
                      :options="availableTags"
                      label="name"
                      track-by="id"
                      :multiple="true"
                      :close-on-select="false"
                      :show-labels="false"
                      placeholder="Selecione as tags…"
                      @input="(val) => onBundleTagsChange(idx, val)"
                    />
                  </div>
                </div>
              </div>
              <div v-else class="text-muted small mb-2">
                Nenhum grupo definido. Adicione um pra começar.
              </div>

              <button type="button" class="btn btn-outline-info btn-sm" @click="addBundle()">
                <i class="mdi mdi-plus mr-1"></i> Adicionar Grupo
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveControl()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { listForms, listTags } from './services'

export default {
  components: {
    Loading,
    Multiselect
  },
  props: {
    controlData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo Controle de Inscrição',
      loading: false,
      submitted: false,
      control: {
        name: '',
        identifier_label: '',
        identifier_field: '',
        identifier_mask: '',
        vacancy_mode: 'per_item',
        vacancy_message: '',
        assign_participant_group: false,
        active: true,
        form_id: null,
        fields_schema: [],
        tag_bundles: []
      },
      maskType: '',
      predefinedMasks: ['###.###.###-##', '##.###.###/####-##', '(##) #####-####', '#####-###'],
      forms: [],
      availableTags: [],
      modal: false
    }
  },
  validations: {
    control: {
      name: { required },
      identifier_label: { required },
      identifier_field: { required },
      vacancy_mode: { required },
      form_id: { required }
    }
  },
  computed: {
    maskPreview () {
      if (!this.control.identifier_mask) return ''
      return this.control.identifier_mask
        .replace(/#/g, '0')
        .replace(/A/g, 'A')
        .replace(/S/g, 'X')
    }
  },
  methods: {
    ...mapActions('registrationControl', {
      postData: 'save'
    }),
    onMaskTypeChange () {
      if (this.maskType === 'custom') {
        this.control.identifier_mask = ''
      } else {
        this.control.identifier_mask = this.maskType
      }
    },
    detectMaskType (mask) {
      if (!mask) return ''
      if (this.predefinedMasks.includes(mask)) return mask
      return 'custom'
    },
    async open (data = null) {
      this.modal = true
      this.loading = false
      this.submitted = false
      this.loadForms()
      this.loadTags()
      if (data) {
        this.title = 'Editar Controle de Inscrição'
        this.control = {
          ...data,
          identifier_mask: data.identifier_mask || '',
          fields_schema: data.fields_schema ? [...data.fields_schema] : [],
          tag_bundles: this.hydrateBundles(data.tag_bundles || [])
        }
        this.maskType = this.detectMaskType(data.identifier_mask)
      } else {
        this.title = 'Novo Controle de Inscrição'
        this.control = {
          name: '',
          identifier_label: '',
          identifier_field: '',
          identifier_mask: '',
          vacancy_mode: 'per_item',
          vacancy_message: '',
          assign_participant_group: false,
          active: true,
          form_id: null,
          fields_schema: [],
          tag_bundles: []
        }
        this.maskType = ''
      }
    },
    /**
     * Hidrata bundles vindo do backend (que têm tag_ids: number[]) pro
     * shape que o multiselect espera (selectedTags: object[]).
     * Como availableTags pode ainda não estar carregado quando open()
     * roda, guardamos os tag_ids brutos pra reconciliar depois.
     */
    hydrateBundles (rawBundles) {
      return rawBundles.map(b => ({
        id: b.id,
        name: b.name || '',
        tag_ids: Array.isArray(b.tag_ids) ? [...b.tag_ids] : [],
        selectedTags: this.matchTagsByIds(b.tag_ids || [])
      }))
    },
    matchTagsByIds (ids) {
      if (!this.availableTags.length || !ids.length) return []
      const set = new Set(ids.map(Number))
      return this.availableTags.filter(t => set.has(Number(t.id)))
    },
    async loadTags () {
      try {
        const { data } = await listTags()
        this.availableTags = data.data || data || []
        // Reconcilia bundles já hidratados parcialmente (caso open() tenha
        // rodado antes do load das tags terminar)
        if (this.control.tag_bundles && this.control.tag_bundles.length) {
          this.control.tag_bundles.forEach(b => {
            if (!b.selectedTags || !b.selectedTags.length) {
              b.selectedTags = this.matchTagsByIds(b.tag_ids || [])
            }
          })
        }
      } catch (e) {
        this.availableTags = []
      }
    },
    addBundle () {
      if (!this.control.tag_bundles) this.control.tag_bundles = []
      this.control.tag_bundles.push({
        id: null, // backend atribui id local na hora do save
        name: '',
        tag_ids: [],
        selectedTags: []
      })
    },
    removeBundle (idx) {
      this.control.tag_bundles.splice(idx, 1)
    },
    onBundleTagsChange (idx, selected) {
      const bundle = this.control.tag_bundles[idx]
      if (!bundle) return
      bundle.tag_ids = (selected || []).map(t => Number(t.id))
    },
    async loadForms () {
      try {
        const { data } = await listForms({ type: 'registration' })
        this.forms = data.data || data || []
      } catch (e) {
        this.forms = []
      }
    },
    slugify (str) {
      return str
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_|_$/g, '')
    },
    onFieldTypeChange (field) {
      if (field.type === 'select' || field.type === 'multiselect') {
        if (!field.options) {
          this.$set(field, 'options', [''])
        }
      }
    },
    addField () {
      if (!this.control.fields_schema) {
        this.control.fields_schema = []
      }
      this.control.fields_schema.push({ name: '', label: '', type: 'text' })
    },
    removeField (index) {
      this.control.fields_schema.splice(index, 1)
    },
    async saveControl () {
      this.submitted = true
      this.$v.control.$touch()
      if (this.$v.control.$invalid) {
        return
      }
      this.loading = true
      // Serializa bundles pro shape esperado pelo backend (sem selectedTags)
      const payload = {
        ...this.control,
        tag_bundles: (this.control.tag_bundles || []).map(b => ({
          id: b.id || null,
          name: b.name,
          tag_ids: b.tag_ids || []
        }))
      }
      await this.postData(payload).then(() => {
        successMessage('Sucesso: Dados armazenados com sucesso.', 2500)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + (err.response ? err.response.data.message : err.message))
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.control = {
        name: '',
        identifier_label: '',
        identifier_field: '',
        identifier_mask: '',
        vacancy_mode: 'per_item',
        vacancy_message: '',
        assign_participant_group: false,
        active: true,
        form_id: null,
        fields_schema: [],
        tag_bundles: []
      }
      this.maskType = ''
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}

.tb-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.tb-card {
  background: #fafbfc;
  border: 1px solid #eaecf2;
  border-radius: 8px;
  padding: 12px 14px;
}

.tb-card-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.tb-name-wrap {
  flex: 1;
  min-width: 0;
}

.tb-remove {
  flex-shrink: 0;
}

label {
  display: flex;
  align-items: center;
}

.info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  cursor: help;
  position: relative;
  color: inherit;
  opacity: 0.75;
  transition: opacity 0.2s ease;
}

.info-tooltip:hover {
  opacity: 1;
}

.info-tooltip svg {
  display: block;
}

.info-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background-color: #1e293b;
  color: #f1f5f9;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  white-space: normal;
  max-width: 280px;
  width: max-content;
  z-index: 1060;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.info-tooltip:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
</style>
